<template>
  <section class="loyaltyHeader">
    <div class="container">
      <div v-if="data" class="loyaltyHeader__ProfileInfos">
        <span>
          {{ $t('greeting') }}
          <template v-if="data.profile.first_name">{{ data.profile.first_name }}</template> <template v-if="data.profile.last_name">{{ data.profile.last_name }}</template>
        </span><span>{{ $t('points') }} {{ data.loyalty.cumulative_points || 0 }}</span> 
      </div>

      <nav class="loyaltyHeader__Links">
        <ul>
          <li v-for="item in links">
            <nuxt-link :to="link(`${ item.id }`)">{{ $t(`loyalty.${ item.labelId }`) }}</nuxt-link>
          </li>
        </ul>
      </nav>
    </div>
  </section>
</template>

<script setup>
  const { link } = useSetup();
  const { data } = useAuth();

  const links = [
    { id: 'LoyaltyDashboard', labelId: 'home' },
    { id: 'Points', labelId: 'points' },
    { id: 'Stays', labelId: 'stays' },
    { id: 'Profile', labelId: 'profile' },
    { id: 'LoyaltyFAQ', labelId: 'faq' },
    { id: 'LoyaltyTerms', labelId: 'terms' },
  ];
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_loyaltyHeader.scss');
</style>